import script from "./ServiceNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceNumber.vue?vue&type=script&setup=true&lang=js"

import "./ServiceNumber.vue?vue&type=style&index=0&id=32237520&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32237520"]])

export default __exports__